import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';

@Injectable()
export class AssetsTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string) {
    const url = `/assets/i18n/${lang}.json`;
    return this.http.get<Record<string, string>>(url);
  }
}
